// 存储首页数据
export default {
  namespaced: true,
  state: {
    homeConfig: {}
  },
  getters: {
    homeConfig: state => state.homeConfig
  },
  mutations: {
    updateHomeConfig(state, payload) {
      state.homeConfig = payload
    }
  },
  actions: {
    updateHomeConfig(context, payload) {
      context.commit('updateHomeConfig', payload)
    }
  }
}
